import React from "react";

import "./BackdropImage.scss";

const BackdropImage = ({ children }) => (
    <div className="backdrop-image">
        {children}
        <div className="backdrop-image__cover"></div>
    </div>
);

export default BackdropImage;
